import request from 'Request'

const JourneyService = {
  async list({ appCodes }) {
    return request.post('/journey/list', { appCodes })
  }
}

export default JourneyService
